import { render, staticRenderFns } from "./ListLots.vue?vue&type=template&id=3b034587&"
import script from "./ListLots.vue?vue&type=script&lang=ts&"
export * from "./ListLots.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports